import { getAuthHeader } from '@/utils';

import { BASE_URL } from '../constants';

/**
 * Checks if current medical center user is insolvent
 * @author gabrielm
 */
export async function getIsInsolvent() {
  try {
    const response = await fetch(`${BASE_URL}insurance/is-insolvent/`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    if (!response.ok) {
      throw new Error(`Error fetching is-insolvent: ${response.statusText}`);
    }
    /** @type {{is_insolvent: boolean}} */
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching is-insolvent: ', error.message);
    return { is_insolvent: false };
  }
}
